module.exports = __webpack_public_path__ + "images/6d0d96412ac5a834745e37ec7cbe5a61.png";